<template>
    <el-drawer :visible.sync="drawerVisible" :with-header="true" append-to-body size="560px" title="修改客人名单"
               @open="handleOpen">
        <div v-loading="loading" class="guest-edit-page">
            <!-- 顶部信息 -->
            <div class="info-header">
                <div class="info-row">
                    <span class="info-label">订单编号：</span>
                    <span class="info-value">{{ orderChildId }}</span>
                </div>
                <div class="info-row">
                    <span class="info-label">入住酒店：</span>
                    <span class="info-value">{{ hotelName }}</span>
                </div>
            </div>

            <!-- 操作按钮 -->
            <div class="action-btns">
                <el-button icon="el-icon-download" size="small" @click="handleDownloadTemplate">下载上传名单模板</el-button>
                <el-upload
                    :http-request="uploadGuestFile"
                    :show-file-list="false"
                    accept=".xlsx,.xls"
                    action="#"
                >
                    <el-button icon="el-icon-paperclip" size="small">上传名单</el-button>
                </el-upload>
            </div>

            <!-- 行程段列表 -->
            <div v-for="(stay, sIdx) in roomListData" :key="sIdx" class="stay-list">
                <!-- 日期标题 -->
                <div class="stay-title">{{ stay.checkinDate }} &rarr; {{ stay.checkoutDate }}</div>

                <!-- 房间列表 -->
                <div v-for="(room, rIdx) in stay.roomList" :key="rIdx" class="room-block">
                    <div class="room-type-header">
                        <span class="room-type-name">{{ room.roomName || 'Standard Room' }}</span>
                        <span class="room-count">{{ stay.roomList.length }} 间</span>
                    </div>
                    <div class="room-label-row">
                        <span class="room-label">房间 {{ room.roomNumber || (rIdx + 1) }}</span>
                    </div>

                    <!-- 入住人列表 -->
                    <div v-for="(guest, gIdx) in room.customInfos" :key="gIdx" class="guest-item">
                        <div class="guest-row">
                            <div class="guest-field">
                                <span class="field-label">中文名</span>
                                <el-input v-model="guest.name" placeholder="请输入中文名" size="small"></el-input>
                            </div>
                            <div class="guest-field">
                                <span class="field-label">英文名</span>
                                <el-input v-model="guest.nameEn" placeholder="请输入英文名" size="small"></el-input>
                            </div>
                        </div>
                        <div class="guest-row">
                            <div class="guest-field">
                                <span class="field-label">性别</span>
                                <el-select v-model="guest.sex" size="small" style="width: 100%">
                                    <el-option label="男" value="男"></el-option>
                                    <el-option label="女" value="女"></el-option>
                                </el-select>
                            </div>
                            <div class="guest-field">
                                <span class="field-label">身份证号/护照号</span>
                                <el-input v-model="guest.passprotNumber" placeholder="请输入身份证号或护照号"
                                          size="small"></el-input>
                            </div>
                        </div>
                        <div class="guest-actions">
                            <el-link v-if="room.customInfos.length > 1" :underline="false" type="danger"
                                     @click="removeGuest(sIdx, rIdx, gIdx)">删除
                            </el-link>
                        </div>
                    </div>

                    <!-- 添加入住人 -->
                    <div class="add-btn" @click="addGuest(sIdx, rIdx)">
                        <span>+ 添加入住人</span>
                    </div>
                </div>
            </div>

            <!-- 底部保存按钮 -->
            <div class="bottom-bar">
                <el-button :loading="saving" style="width: 100%; height: 44px; font-size: 15px; font-weight: 700;"
                           type="primary"
                           @click="handleSave">保 存
                </el-button>
            </div>
        </div>
    </el-drawer>
</template>

<script>
import Api from '@/components/Api/index'

export default {
    name: 'GuestEditDrawer',
    data() {
        return {
            drawerVisible: false,
            orderChildId: '',
            hotelName: '',
            roomListData: [],
            loading: false,
            saving: false,
        }
    },
    methods: {
        // 打开抽屉 - 由父组件调用
        open(orderChildId, hotelName) {
            this.orderChildId = orderChildId || ''
            this.hotelName = hotelName || ''
            this.roomListData = []
            this.drawerVisible = true
        },

        // 抽屉打开时加载数据
        handleOpen() {
            if (this.orderChildId) {
                this.fetchGuestData()
            }
        },

        // 获取客人名单数据
        fetchGuestData() {
            this.loading = true
            new Api('').getRoomList(this.orderChildId).then(res => {
                if (res.status === 200 && res.data && Array.isArray(res.data)) {
                    this.roomListData = res.data
                } else {
                    this.roomListData = []
                }
            }).catch(() => {
                this.$message.error('获取客人名单失败')
                this.roomListData = []
            }).finally(() => {
                this.loading = false
            })
        },

        // 添加入住人
        addGuest(sIdx, rIdx) {
            const room = this.roomListData[sIdx].roomList[rIdx]
            const last = room.customInfos[room.customInfos.length - 1]
            room.customInfos.push({
                ...last,
                id: null,
                name: '',
                nameEn: '',
                sex: '男',
                passprotNumber: ''
            })
        },

        // 移除入住人
        removeGuest(sIdx, rIdx, gIdx) {
            const room = this.roomListData[sIdx].roomList[rIdx]
            this.$confirm('确定移除该入住人吗？', '提示', {type: 'warning'}).then(() => {
                room.customInfos.splice(gIdx, 1)
            }).catch(() => {
            })
        },

        // 下载模板
        handleDownloadTemplate() {
            if (!this.orderChildId) {
                this.$message.warning('缺少订单参数')
                return
            }
            const url = `${process.env.VUE_APP_SERVE_NEW}/customizerWeb/v1/order/downloadGuestList?childrenId=${this.orderChildId}`
            fetch(url, {
                method: 'GET',
                headers: {'token': this.$store.state.newAccessToken}
            }).then(async (response) => {
                if (!response.ok) throw new Error('下载失败')
                const blob = await response.blob()
                const link = document.createElement('a')
                link.href = URL.createObjectURL(blob)
                link.download = `入住人模版${this.orderChildId}.xlsx`
                document.body.appendChild(link)
                link.click()
                document.body.removeChild(link)
                URL.revokeObjectURL(link.href)
            }).catch(() => {
                this.$message.error('下载模板失败')
            })
        },

        // 上传文件到服务器
        uploadGuestFile(options) {
            if (!this.orderChildId) {
                this.$message.warning('缺少订单参数')
                return
            }
            const formData = new FormData()
            formData.append('file', options.file)

            const uploadUrl = `${process.env.VUE_APP_SERVE_NEW}/customizerWeb/v1/order/guestsUpload/${this.orderChildId}`

            this.loading = true
            fetch(uploadUrl, {
                method: 'POST',
                body: formData,
                headers: {
                    'token': this.$store.state.newAccessToken
                }
            }).then(async (response) => {
                const data = await response.json()
                if (data.status === 200) {
                    this.$message.success('上传成功')
                    this.fetchGuestData()
                } else {
                    this.$message.error('上传失败')
                }
            }).catch(() => {
                this.$message.error('上传失败，请重试')
            }).finally(() => {
                this.loading = false
            })
        },

        // 保存
        handleSave() {
            let hasError = false
            for (let s = 0; s < this.roomListData.length; s++) {
                const stay = this.roomListData[s]
                for (let r = 0; r < stay.roomList.length; r++) {
                    const room = stay.roomList[r]
                    for (let g = 0; g < room.customInfos.length; g++) {
                        const guest = room.customInfos[g]
                        if (!guest.name || !guest.nameEn || !guest.passprotNumber) {
                            hasError = true
                            break
                        }
                    }
                    if (hasError) break
                }
                if (hasError) break
            }

            if (hasError) {
                this.$message.warning('请完善所有入住人的中文名、英文名和证件号')
                return
            }

            // 收集所有 customInfos 作为参数
            const customInfosList = []
            for (const stay of this.roomListData) {
                for (const room of stay.roomList) {
                    if (room.customInfos && room.customInfos.length > 0) {
                        customInfosList.push(...room.customInfos)
                    }
                }
            }

            this.saving = true
            new Api('').saveRoomCustom(customInfosList).then((res) => {
                if(res.status === 200) {
                    this.$message.success('保存成功')
                    this.drawerVisible = false
                    this.$emit('saved')
                }else {
                    this.$message.error('保存失败')
                }
            }).catch(() => {
                this.$message.error('保存失败')
            }).finally(() => {
                this.saving = false
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.guest-edit-page {
    min-height: 100%;
    background: #f5f7fa;
    padding-bottom: 70px;
}

/* ========== 顶部信息 ========== */
.info-header {
    background: #fff;
    padding: 12px 16px;
}

.info-row {
    display: flex;
    align-items: center;
    margin-bottom: 6px;

    &:last-child {
        margin-bottom: 0;
    }
}

.info-label {
    font-size: 13px;
    color: #8e99a8;
}

.info-value {
    font-size: 13px;
    color: #1a1a2e;
    font-weight: 600;
}

/* ========== 操作按钮 ========== */
.action-btns {
    display: flex;
    gap: 10px;
    padding: 10px 16px;
    background: #fff;
    border-top: 1px solid #f0f2f5;
    border-bottom: 1px solid #f0f2f5;
}

/* ========== 行程标题 ========== */
.stay-list {
    padding: 0 16px;
}

.stay-title {
    font-size: 15px;
    font-weight: 700;
    color: #2d3b6e;
    margin: 16px 0 8px;
}

/* ========== 房型头 ========== */
.room-type-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 0;
    border-bottom: 1px solid #f0f2f5;
    margin-bottom: 6px;
}

.room-type-name {
    font-size: 14px;
    font-weight: 700;
    color: #1a1a2e;
}

.room-count {
    font-size: 12px;
    color: #e67e22;
    font-weight: 600;
}

/* ========== 房间块 ========== */
.room-block {
    margin-bottom: 14px;
    background: #fff;
    border-radius: 10px;
    padding: 12px;
}

.room-label-row {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 8px 0 6px;
}

.room-label {
    font-size: 13px;
    font-weight: 600;
    color: #1a1a2e;
}

/* ========== 入住人条目 ========== */
.guest-item {
    display: flex;
    flex-direction: column;
    gap: 10px;
    padding: 10px 0;
    border-bottom: 1px dashed #edf0f4;
    margin-bottom: 8px;

    &:last-child {
        border-bottom: none;
    }
}

.guest-row {
    display: flex;
    gap: 10px;
}

.guest-field {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 3px;
}

.field-label {
    font-size: 11px;
    font-weight: 600;
    color: #8e99a8;
}

/* 移除按钮 */
.guest-actions {
    display: flex;
    justify-content: flex-end;
}

/* ========== 添加入住人 ========== */
.add-btn {
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px dashed #dce0e8;
    padding: 10px;
    border-radius: 8px;
    color: #2d3b6e;
    font-size: 13px;
    font-weight: 600;
    margin-top: 8px;
    cursor: pointer;

    &:hover {
        background: #f8f9fc;
    }
}

/* ========== 底部保存栏 ========== */
.bottom-bar {
    position: sticky;
    bottom: 0;
    left: 0;
    right: 0;
    background: #fff;
    padding: 12px 16px;
    box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
}
</style>
